import { render } from "./PackageDetail.vue?vue&type=template&id=b6bcc0e8"
import script from "./PackageDetail.vue?vue&type=script&lang=js"
export * from "./PackageDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__